export default __webpack_public_path__ + "static/media/chart1.03606964.png";